import React, { useEffect } from "react";
import { styled } from "@mui/material/styles";
import { X } from "react-feather";
import { tokens as t } from "./tokens";

const Overlay = styled("div")({
  position: "fixed",
  inset: 0,
  background: "rgba(16,36,60,.42)",
  backdropFilter: "blur(3px)",
  zIndex: 1300,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 20,
  animation: "adminFade .2s ease",
  "@keyframes adminFade": { from: { opacity: 0 }, to: { opacity: 1 } },
});
const Panel = styled("div")(({ width }) => ({
  background: t.color.surface,
  borderRadius: 18,
  width: "100%",
  maxWidth: width || 520,
  boxShadow: t.shadow.lg,
  overflow: "hidden",
  animation: "adminPop .24s cubic-bezier(.2,.9,.3,1.2)",
  "@keyframes adminPop": {
    from: { opacity: 0, transform: "scale(.96) translateY(8px)" },
    to: { opacity: 1, transform: "none" },
  },
}));
const Head = styled("div")({ display: "flex", alignItems: "flex-start", gap: 14, padding: "22px 24px 16px" });
const MIcon = styled("div")({
  width: 42,
  height: 42,
  borderRadius: 12,
  background: t.color.brandSoft,
  color: t.color.brandDark,
  display: "grid",
  placeItems: "center",
  flex: "none",
  "& svg": { width: 22, height: 22 },
});
const Close = styled("button")({
  marginLeft: "auto",
  width: 34,
  height: 34,
  borderRadius: 9,
  display: "grid",
  placeItems: "center",
  color: t.color.muted,
  border: "none",
  background: "none",
  cursor: "pointer",
  "&:hover": { background: t.color.canvas, color: t.color.ink },
  "& svg": { width: 18, height: 18 },
});
const Body = styled("div")({ padding: "6px 24px 8px", maxHeight: "62vh", overflowY: "auto" });
const Foot = styled("div")({
  display: "flex",
  gap: 12,
  padding: "16px 24px 22px",
  borderTop: `1px solid ${t.color.line2}`,
  marginTop: 8,
});

export const ModalHeader = ({ icon: Icon, title, desc, onClose }) => (
  <Head>
    {Icon && (
      <MIcon>
        <Icon />
      </MIcon>
    )}
    <div>
      <h3 style={{ fontFamily: t.font.display, fontSize: 17, fontWeight: 800, color: t.color.text }}>{title}</h3>
      {desc && <p style={{ color: t.color.muted, fontSize: 12.5, marginTop: 2 }}>{desc}</p>}
    </div>
    <Close onClick={onClose} aria-label="Хаах">
      <X />
    </Close>
  </Head>
);

export const ModalBody = Body;
export const ModalFooter = Foot;

const Modal = ({ open, onClose, width, children }) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <Overlay onMouseDown={(e) => e.target === e.currentTarget && onClose?.()}>
      <Panel width={width} onMouseDown={(e) => e.stopPropagation()}>
        {children}
      </Panel>
    </Overlay>
  );
};

export default Modal;
